/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './mpps.reducer';

export const MPPS = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const mPPSList = useAppSelector(state => state.mPPS.entities);
  const loading = useAppSelector(state => state.mPPS.loading);
  const totalItems = useAppSelector(state => state.mPPS.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="mpps-heading" data-cy="MPPSHeading">
        <Translate contentKey="tinyMedicRestApp.mPPS.home.title">MPPS</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.mPPS.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/mpps/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.mPPS.home.createLabel">Create new MPPS</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.mPPS.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {mPPSList && mPPSList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.mPPS.id">Id</Translate> <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('accessionNo')}>
                  <Translate contentKey="tinyMedicRestApp.mPPS.accessionNo">Accession No</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('accessionNo')} />
                </th>
                <th className="hand" onClick={sort('createdTime')}>
                  <Translate contentKey="tinyMedicRestApp.mPPS.createdTime">Created Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdTime')} />
                </th>
                <th className="hand" onClick={sort('ppsStartDate')}>
                  <Translate contentKey="tinyMedicRestApp.mPPS.ppsStartDate">Pps Start Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ppsStartDate')} />
                </th>
                <th className="hand" onClick={sort('ppsStartTime')}>
                  <Translate contentKey="tinyMedicRestApp.mPPS.ppsStartTime">Pps Start Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ppsStartTime')} />
                </th>
                <th className="hand" onClick={sort('sopIuid')}>
                  <Translate contentKey="tinyMedicRestApp.mPPS.sopIuid">Sop Iuid</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sopIuid')} />
                </th>
                <th className="hand" onClick={sort('ppsStatus')}>
                  <Translate contentKey="tinyMedicRestApp.mPPS.ppsStatus">Pps Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ppsStatus')} />
                </th>
                <th className="hand" onClick={sort('studyIuid')}>
                  <Translate contentKey="tinyMedicRestApp.mPPS.studyIuid">Study Iuid</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('studyIuid')} />
                </th>
                <th className="hand" onClick={sort('updatedTime')}>
                  <Translate contentKey="tinyMedicRestApp.mPPS.updatedTime">Updated Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('updatedTime')} />
                </th>
                <th className="hand" onClick={sort('dicomAttrs')}>
                  <Translate contentKey="tinyMedicRestApp.mPPS.dicomAttrs">Dicom Attrs</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dicomAttrs')} />
                </th>
                <th className="hand" onClick={sort('discreasonCode')}>
                  <Translate contentKey="tinyMedicRestApp.mPPS.discreasonCode">Discreason Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discreasonCode')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.mPPS.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.mPPS.accnoIssuer">Accno Issuer</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {mPPSList.map((mPPS, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/mpps/${mPPS.id}`} color="link" size="sm">
                      {mPPS.id}
                    </Button>
                  </td>
                  <td>{mPPS.accessionNo}</td>
                  <td>{mPPS.createdTime}</td>
                  <td>{mPPS.ppsStartDate}</td>
                  <td>{mPPS.ppsStartTime}</td>
                  <td>{mPPS.sopIuid}</td>
                  <td>{mPPS.ppsStatus}</td>
                  <td>{mPPS.studyIuid}</td>
                  <td>{mPPS.updatedTime}</td>
                  <td>{mPPS.dicomAttrs}</td>
                  <td>{mPPS.discreasonCode}</td>
                  <td>{mPPS.patient ? <Link to={`/gluco-user/${mPPS.patient.id}`}>{mPPS.patient.id}</Link> : ''}</td>
                  <td>{mPPS.accnoIssuer ? <Link to={`/diag-lab/${mPPS.accnoIssuer.id}`}>{mPPS.accnoIssuer.id}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/mpps/${mPPS.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/mpps/${mPPS.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/mpps/${mPPS.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.mPPS.home.notFound">No MPPS found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={mPPSList && mPPSList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default MPPS;
